import * as vp from 'vopay';

const apiBaseUrl = import.meta.env.VITE_GLOBAL_PAY_API || '';

export default vp.VoPayApi(apiBaseUrl);
